import React from "react";

const HireMeBtn = () => {
  return (
    <a
      href="mailto:ahmaddin1000@gmail.com?subject=Hire Me - Ahmaddin - Software Developer"
      className="flex items-center px-4 py-2 text-white border-2 group bg-violet-600 hover: hover:border-violet-600 hover:bg-[transparent]"
    >
      Hire Me
    </a>
  );
};

export default HireMeBtn;
